// extracted by mini-css-extract-plugin
export default {"facebook":"Button_facebook__u-yNE","apple":"Button_apple__9ZLKs","google":"Button_google__P67zN","gray":"Button_gray__AU-i5"};